// extracted by mini-css-extract-plugin
export var accordionContainer = "styles-module__accordionContainer___BH34d";
export var hidePanel = "styles-module__hidePanel___RbX83";
export var panel = "styles-module__panel___baShW";
export var panelBottom = "styles-module__panelBottom___jWnlr";
export var panelJib = "styles-module__panelJib___i4nrg";
export var panelSpacer = "styles-module__panelSpacer___BbdCh";